/**
 * VersionChecker - Detecta cuando hay una nueva versión de la aplicación
 * y notifica al usuario para que recargue la página
 */

import { useEffect, useState } from 'react';

interface VersionInfo {
  version: string;
  buildTime: string;
  buildTimestamp: number;
}

const CHECK_INTERVAL = 5 * 60 * 1000; // Verificar cada 5 minutos

export const VersionChecker = () => {
  const [currentVersion, setCurrentVersion] = useState<VersionInfo | null>(null);
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);

  // Cargar versión actual al montar el componente
  useEffect(() => {
    fetchVersion().then(setCurrentVersion);
  }, []);

  // Verificar periódicamente si hay nueva versión
  useEffect(() => {
    const interval = setInterval(async () => {
      if (!currentVersion) return;

      const latestVersion = await fetchVersion();

      // Si el timestamp del build es diferente, hay una nueva versión
      if (latestVersion && latestVersion.buildTimestamp !== currentVersion.buildTimestamp) {
        console.log('🔄 Nueva versión detectada:', latestVersion.version);
        setShowUpdateBanner(true);
      }
    }, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [currentVersion]);

  const fetchVersion = async (): Promise<VersionInfo | null> => {
    try {
      // Agregar timestamp para evitar caché
      const response = await fetch(`/App/version.json?t=${Date.now()}`);
      return await response.json();
    } catch (error) {
      console.warn('No se pudo verificar la versión:', error);
      return null;
    }
  };

  const handleUpdate = () => {
    // Limpiar caché del navegador y recargar
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    window.location.reload();
  };

  if (!showUpdateBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#0066cc',
      color: 'white',
      padding: '12px 20px',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      fontFamily: 'Quicksand, sans-serif'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '20px' }}>🔄</span>
        <span>
          <strong>Nueva versión disponible</strong> - Hay una actualización de la aplicación
        </span>
      </div>
      <button
        onClick={handleUpdate}
        style={{
          backgroundColor: 'white',
          color: '#0066cc',
          border: 'none',
          padding: '8px 20px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: '14px',
          fontFamily: 'Quicksand, sans-serif'
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
      >
        Actualizar ahora
      </button>
    </div>
  );
};

export default VersionChecker;
